// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".event-card[data-v-4e129fa6]{height:225px;min-height:225px;min-width:225px;width:225px}.event-card__timestamp[data-v-4e129fa6]{position:absolute;right:10px;top:10px}.event-card__btn[data-v-4e129fa6]{bottom:10px;position:absolute;right:10px}.event-card__title[data-v-4e129fa6]{word-wrap:anywhere}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
